import { Container } from '@/components/container';
import { Demo4Content } from '.';
const Demo4Page = () => {
  return <Container>
      <Demo4Content />
    </Container>;
};
export { Demo4Page };